import { DraggableList } from "./DraggableList"
import { ImportCandidatesButton } from "./ImportCandidatesButton"
import { ItemEntry } from "./ItemEntry"
import { ListHeader } from "./ListHeader"
import { SkeletonList } from "./SkeletonList"

export type Item = {
  id: string
  content: string | null
}

export function EditableList({
  ready,
  items,
  onAddItem,
  onRemoveItem,
  onReordered,
}: {
  ready: boolean
  items: Item[]
  onAddItem: (m: Item) => void
  onRemoveItem: any
  onReordered: (r: string[]) => void
}) {
  return (
    <>
      <ListHeader>
        <ItemEntry onSubmit={ready && onAddItem} />
      </ListHeader>
      <ImportCandidatesButton
        disabled={!ready}
        onImport={(items) => items.forEach(onAddItem)}
      />
      {ready || <SkeletonList />}
      <DraggableList
        onRemoveItem={onRemoveItem}
        items={items}
        onReordered={onReordered}
      />
    </>
  )
}
